<template>
    <div>
        <b-img 
            src="https://www.flaticon.com/svg/static/icons/svg/32/32724.svg" 
            width="15" 
            alt="Left image"
            v-for="n in parseInt(rating)" 
            v-bind:key="n"
        >
        </b-img>
    </div>
</template>

<style scoped>
    
</style>

<script>
export default {
    components: {
        
    },
    props: {
        rating: {
            type: Number
        }
    },
    data() {
        return {

        }
    },
    computed: {

    }
}
</script>